import React from "react";

const RepoussePlate = () => {
  return (
    <div className="upcharge-description large-plate-desc">
      <h3 className="upcharge-description__header">
        Foil Embossed plate charge + $25
      </h3>
      <p>Foil Embossed Plate Charge of $25 will be added at checkout.</p>
    </div>
  );
};

export default RepoussePlate;
